import { DatePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import DocumentoVersao from "model/documentos/DocumentoVersao";
import DocumentoVersaoLocal from "model/documentos/DocumentoVersaoLocal";
import Local from "model/patrimonio/Local";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import DocumentoVersaoService from "service/documentos/DocumentoVersaoService";


interface ModalControleDistribuicaoProps {
    visible: boolean;
    onHide: () => void;
    documentoVersao: DocumentoVersao | null;
    documentoVersaoLocal: DocumentoVersaoLocal | null;
}

const documentoVersaoService = new DocumentoVersaoService();

export default function ModalControleDistribuicao(props: ModalControleDistribuicaoProps) {

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    const [locais, setLocais] = useState<Local[]>([]);
    const [documentoVersaoLocal, setDocumentoVersaoLocal] = useState<DocumentoVersaoLocal>(new DocumentoVersaoLocal());

    useEffect(() => {
        documentoVersaoService.locais().then(resposta => {
            setLocais(resposta);
        });

        if (props.documentoVersaoLocal) {
            setDocumentoVersaoLocal(props.documentoVersaoLocal);
        } else {
            setDocumentoVersaoLocal({ ...documentoVersaoLocal, documentoVersao: props.documentoVersao });
        }

    }, [])

    function salvarDistribuicao() {
        startLoading();
        const serviceCall = props.documentoVersaoLocal?.id == 0
            ? documentoVersaoService.editarDistribuicao(documentoVersaoLocal)
            : documentoVersaoService.incluirDistribuicao(documentoVersaoLocal);

        serviceCall
            .then(resposta => {
                props.onHide();
                msgSucesso('Documento Versão', 'Registro gravado com sucesso');
                stopLoading();
            })
            .catch(error => {
                console.error(error);
                if (error && error.data && error.data.message) {
                    msgErro('Documento Versão', error.data.message);
                } else {
                    msgErro('Documento Versão', 'Ocorreu um erro ao tentar gravar, tente novamente!');
                }
                stopLoading();
            });
    }

    const footer = <div>
        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-danger" onClick={props.onHide} />
        <Button label="Gravar" icon="pi pi-check" className="p-button-text" onClick={() => salvarDistribuicao()} />
    </div>


    return (
        <>
            <Dialog visible={props.visible} baseZIndex={100} style={{ width: '65vw', minHeight: "50vh" }} modal onHide={props.onHide}
                header="Lançar Distribuição" footer={footer}>

                <div className="row">
                    <Label className="col col-sm-12">Local</Label>
                    <div className="col-sm-12">
                        <Dropdown
                            options={locais}
                            optionLabel="nome"
                            placeholder="Selecione"
                            value={documentoVersaoLocal.local}
                            style={{ width: '30%' }}
                            onChange={(e) => {
                                setDocumentoVersaoLocal({ ...documentoVersaoLocal, local: e.value as Local })
                            }}
                        />
                    </div>
                </div>

                <div className="row">
                    <Label className="col col-sm-12">Data Entrada</Label>
                    <div className="col-sm-12">
                        <DatePicker
                            slotProps={{ popper: { disablePortal: true } }}
                            value={dayjs(documentoVersaoLocal.dataEntrada)}
                            onChange={value => {
                                setDocumentoVersaoLocal({ ...documentoVersaoLocal, dataEntrada: value?.toDate() || null })
                            }}
                        />
                    </div>
                </div>

                <div className="row">
                    <Label className="col col-sm-12">Cópias</Label>
                    <div className="col-sm-12">
                        <InputNumber
                            value={documentoVersaoLocal.copias}
                            style={{ width: '30%' }}
                            onChange={(e) => setDocumentoVersaoLocal({ ...documentoVersaoLocal, copias: e.value as number })}
                        />
                    </div>
                </div>

                <div className="row">
                    <Label className="col col-sm-12">Observação</Label>
                    <div className="col-sm-12">
                        <InputTextarea
                            value={documentoVersaoLocal.observacao}
                            style={{ width: '100%' }}
                            onChange={(e) => setDocumentoVersaoLocal({ ...documentoVersaoLocal, observacao: e.target.value })}
                        />
                    </div>
                </div>

            </Dialog>
        </>
    )
}